/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function SwatchNib(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'SwatchNib',
      'aria-hidden': true,
      focusable: false,
      width:  8 * scale,
      height: 8 * scale,
      viewBox: '0 0 8 8',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m0 8 8-8v8z","fill":"rgba(0, 0, 0, .8)"}),createElement('path', {"d":"m1 8 7-7v7z","fill":"currentColor"}))
}
